import type { ToolModule } from '../../core/modules/types'
import { RegistrationView } from './view'

export const registrationModule: ToolModule = {
  id: 'registration',
  title: 'Customer Registration',
  description: 'Run a full customer registration + IDV, then simulate a payment (dev/staging).',
  requiresToken: true,
  View: RegistrationView,
}
